import React from "react";
import { useState, useImperativeHandle, forwardRef } from "react";
import { _sendInstructionBike,_gearsBike,_voltageBike } from "@/statics/js/api.js";
import { Form, Modal, message, Radio,Spin } from "antd";
import './index.less'

const instructTypeOptions = [
  {value: 1,label: '锁车', extra: '锁定'},
  {value: 2,label: '开锁', extra: '未锁'},
]
const gearsOptions = [
  {value: 1,label: '一档'},
  {value: 2,label: '二档'},
]
const voltageOptions = [
  {value: 1,label: '低'},
  {value: 2,label: '中'},
  {value: 3,label: '高'},
]
const getLabel = ({value,options=[],labelKey='label'})=>{
  const {[labelKey]: label} = options.find(item=>item.value === value) || {}
  return label
}
var Index = forwardRef((props, ref) => {
  const { form, done } = props;
  const { getFieldDecorator,getFieldValue,getFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [detail,setDetail] = useState({})
  const [validate,setValidate] = useState({
    instructType: '',
    gears: '',
    voltage: '',
  })
  useImperativeHandle(
    ref,
    () => ({
      open,
    }),
    []
  );
  const open = async (row) => {
    setLoading(false)
    const info = {
      ...row,
      instructType: typeof row.lock === 'boolean' ? (row.lock ? 1 : 2) : null
    }
    setDetail(info)
    setVisible(true);
    form.resetFields();
    setValidate({})
  };
  const close = async () => {
    setVisible(false);
  };
  // 提交
  const handleOk = async () => {
    if(loading) return;
    const params = getFieldsValue()
    if(!params.instructType && !params.gears && !params.voltage){
      close();
      done();
      return
    }
    const actions = []
    params.instructType && actions.push(sendInstructionBike(params));
    params.gears && actions.push(sendGearsBike(params));
    params.voltage && actions.push(sendVoltageBike(params));
    setConfirmLoading(true);
    const res = await Promise.all(actions)
    setConfirmLoading(false);
    if(res.every(item=>item === 'success')){
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
        close();
        done();
      }, 1000);
    }
  };
  const sendInstructionBike = async (params)=>{
    if(!params.instructType){
      return  
    }
    const res = await _sendInstructionBike({
        id: detail.id,
        instructType: params.instructType
    })
    const { code, message: msg, data } = res.data || {};
    if (code != 200 || data?.code != 0) {
      setValidate(value=>({...value, instructType: 'error'}))
      return
    }
    setValidate(value=>({...value, instructType: 'success'}))
    return 'success'
  }
  const sendGearsBike = async (params)=>{
    if(!params.gears){
      return  
    }
    const res = await _gearsBike({
        id: detail.id,
        type: params.gears
    })
    const { code, message: msg,data } = res.data || {};
    if (code != 200 || data?.code != 200) {
      setValidate(value=>({...value, gears: 'error'}))
      return;
    }
    setValidate(value=>({...value, gears: 'success'}))
    return 'success'
  }
  const sendVoltageBike = async (params)=>{
    if(!params.voltage){
      return  
    }
    const res = await _voltageBike({
        id: detail.id,
        type: params.voltage
    })
    const { code, message: msg,data } = res.data || {};
    if (code != 200 || data?.code != 200) {
      setValidate(value=>({...value, voltage: 'error'}))
      return;
    }
    setValidate(value=>({...value, voltage: 'success'}))
    return 'success'
  }
  const handleInstructType = (e)=>{
    const {value} = e.currentTarget || {}
    const instructType = getFieldValue('instructType')
    if(value == instructType){
      form.setFieldsValue({
        instructType: '',
      })
    }
  }
  const handleGear = (e)=>{
    const {value} = e.currentTarget || {}
    const gears = getFieldValue('gears')
    if(value == gears){
      form.setFieldsValue({
        gears: '',
      })
    }
  }
  const handleVoltage = (e)=>{
    const {value} = e.currentTarget || {}
    const voltage = getFieldValue('voltage')
    if(value == voltage){
      form.setFieldsValue({
        voltage: '',
      })
    }
  }
  return (
    <div>
      <Modal
        title="车辆控制"
        visible={visible}
        width={500}
        onOk={handleOk}
        onCancel={close}
        confirmLoading={confirmLoading}
      >
            <Form className="form_tips">
                <Form.Item label="基础操作" extra={<span className={`validate_${validate.instructType || ''}`}>{validate.instructType ? (validate.instructType === 'error' ? `基础操作指令发送失败，请重试` : `基础操作指令发送成功，请确认车辆状态，若车辆状态未改变，请尝试重试`) : `车辆当前状态为“${getLabel({value: detail.instructType, options: instructTypeOptions,labelKey: 'extra'}) || '未知'}”`}</span>}>
                    {getFieldDecorator("instructType")(
                        <Radio.Group>
                          {
                            instructTypeOptions.map(item=>(
                              <Radio key={item.value} value={item.value} onClick={handleInstructType}>{item.label}</Radio>
                            ))
                          }
                        </Radio.Group>
                    )}
                </Form.Item>
                {
                    !!detail.control && 
                    <>
                        <Form.Item label="档位" extra={<span className={`validate_${validate.gears || ''}`}>{validate.gears ? (validate.gears === 'error' ? `档位指令发送失败，请重试` : `档位指令发送成功，请确认车辆状态，若车辆状态未改变，请尝试重试`) : `车辆当前档位为“${getLabel({value: detail.gears, options: gearsOptions}) || '未知'}”`}</span>}>
                            {getFieldDecorator("gears")(
                                <Radio.Group>
                                  {
                                    gearsOptions.map(item=>(
                                      <Radio key={item.value} value={item.value} onClick={handleGear}>{item.label}</Radio>
                                    ))
                                  }
                                </Radio.Group>
                            )}
                        </Form.Item>
                        <Form.Item label="电压" extra={<span className={`validate_${validate.voltage || ''}`}>{validate.voltage ? (validate.voltage === 'error' ? `电压指令发送失败，请重试` : `电压指令发送成功，请确认车辆状态，若车辆状态未改变，请尝试重试`) : `车辆当前电压为“${getLabel({value: detail.voltage, options: voltageOptions}) || '未知'}”`}</span>}>
                            {getFieldDecorator("voltage")(
                                <Radio.Group>
                                    {
                                      voltageOptions.map(item=>(
                                        <Radio key={item.value} value={item.value} onClick={handleVoltage}>{item.label}</Radio>
                                      ))
                                    }
                                </Radio.Group>
                            )}
                        </Form.Item>
                    </>
                }
            </Form>
      </Modal>
    </div>
  );
});

Index = Form.create({})(Index);
export default Index;
